import React from 'react'
import { Create } from 'react-admin'

import CompetitionsForm from './form'

export const TransfersCreate = (props) => (
  <Create {...props}>
    <CompetitionsForm {...props} />
  </Create>
)

export default TransfersCreate
